import { Theme } from "@mui/material/styles";

export const typographyStyle = (theme: Theme) => ({
  h1: {
    fontSize: "65px",
    fontWeight: 600,
    lineHeight: "65px",
    maxWidth: "fit-content",
    maxHeight: "fit-content",
    color: "#FFFFFF",
    [theme.breakpoints.down("lg")]: {
      fontSize: "50px",
      lineHeight: "50px",
      fontWeight: 600,
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "36px",
      lineHeight: "36px",
      fontWeight: 600,
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "24px",
      lineHeight: "30px",
      fontWeight: 600,
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "72px",
      lineHeight: "72px",
      fontWeight: 600,
    },
  },
  h2: {
    fontSize: "65px",
    fontWeight: 600,
    lineHeight: "65px",
    maxWidth: "fit-content",
    maxHeight: "fit-content",
    color: "#E93571",
    [theme.breakpoints.down("lg")]: {
      fontSize: "50px",
      lineHeight: "50px",
      fontWeight: 600,
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "36px",
      lineHeight: "36px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "24px",
      lineHeight: "30px",
      fontWeight: 600,
    },
  },

  t1: {
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "24px",
    color: "#FFFFFF",
    opacity: ".56",
    maxWidth: "fit-content",
    maxHeight: "fit-content",

    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
      lineHeight: "16px",
      fontWeight: 600,
    },
  },
});
